export const getThemeColors = (dark) => ({
  surface: dark ? "#111827" : "#ffffff",
  surfaceMuted: dark ? "#1f2937" : "#f9fafb",
  overlay: dark ? "rgba(15, 23, 42, 0.75)" : "rgba(15, 23, 42, 0.45)",
  border: dark ? "#374151" : "#e5e7eb",
  borderMuted: dark ? "#4b5563" : "#d1d5db",
  textPrimary: dark ? "#f9fafb" : "#111827",
  textSecondary: dark ? "#d1d5db" : "#6b7280",
  textMuted: dark ? "#9ca3af" : "#4b5563",
  textFaint: dark ? "#6b7280" : "#9ca3af",
  buttonMutedBg: dark ? "#374151" : "#e5e7eb",
  buttonMutedText: dark ? "#f9fafb" : "#111827",
  link: dark ? "#93c5fd" : "#1d4ed8",
  selection: dark ? "rgba(59, 130, 246, 0.2)" : "rgba(59, 130, 246, 0.12)",
  destructiveBg: dark ? "rgba(239, 68, 68, 0.16)" : "#fef2f2",
  destructiveText: dark ? "#fca5a5" : "#991b1b",
  closeButton: dark ? "#9ca3af" : "#6b7280",
});

export const getPillColors = (dark) => ({
  active: {
    color: dark ? "#bbf7d0" : "#1b5e20",
    background: dark ? "rgba(34, 197, 94, 0.2)" : "rgba(27, 94, 32, 0.08)",
  },
  inactive: {
    color: dark ? "#fca5a5" : "#b71c1c",
    background: dark ? "rgba(248, 113, 113, 0.18)" : "rgba(183, 28, 28, 0.08)",
  },
  warning: {
    color: dark ? "#fcd34d" : "#b26a00",
    background: dark ? "rgba(251, 191, 36, 0.22)" : "rgba(178, 106, 0, 0.1)",
  },
  info: {
    color: dark ? "#bfdbfe" : "#01579b",
    background: dark ? "rgba(59, 130, 246, 0.22)" : "rgba(1, 87, 155, 0.1)",
  },
  neutral: {
    color: dark ? "#e5e7eb" : "#37474f",
    background: dark ? "rgba(148, 163, 184, 0.18)" : "rgba(55, 71, 79, 0.08)",
  },
});
